// API Constants
export const API_URL = import.meta.env.VITE_API_BASE_URL || 'https://jsonplaceholder.typicode.com';

// Toast Constants
export const TOAST_LIMIT = 1;
export const TOAST_REMOVE_DELAY = 1000000;

// User Constants
export const USER_ROLE_OPTIONS = ['Admin', 'Manager', 'User'] as const;

export const roleStyles: Record<UserRole, { bg: string; text: string }> = {
  Admin: { bg: '#FDF3E7', text: '#B06A26' },
  Manager: { bg: '#EAF2FF', text: '#2B58D5' },
  User: { bg: '#EAFBF1', text: '#238E55' },
};

// Pagination Constants
export const PAGE_SIZE_OPTIONS = [
  { value: 10, label: "10" },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
] as const;

// Avatar Constants
export const DEFAULT_AVATAR_IMAGES = [
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=80&q=80",
  "https://images.unsplash.com/photo-1494790108755-2616b332c1ca?w=32&h=32&fit=crop&crop=face",
] as const;

export const AVATAR_SIZE = 150;
export const AVATAR_BASE_URL = "https://i.pravatar.cc";

// ID Tag Constants
export const ID_TAG_PATTERNS = {
  ADMIN: (index: number) => `#${(1237 + index).toString().padStart(4, '0')}`,
  USER: (existingCount: number) => `#${(4000 + existingCount + 1).toString()}`,
} as const;

// Type definitions
export type UserRole = (typeof USER_ROLE_OPTIONS)[number];
